export const FILTER = 'FILTER';
export const FULLPROCESS = 'FULLPROCESS';
export const SIMILARITY = 'SIMILARITY';
export const WILDCARDS = 'WILDCARDS';
export const DATASET = 'DATASET';
export const ENTERED_DATASET = 'ENTERED_DATASET';
